import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: [],
    details: []
  },
  getters: {
    list: (state) => state.list,
    details: (state) => state.details,

  },
  actions: {
    fetchSingle({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax.get('CMS/api/PagesQuery/' + id).then(r => {
          commit('setDetails', r.data);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
    create({dispatch }, model) {
      return ajax.post('CMS/api/Pages', model)
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete('CMS/api/Pages', { data: { "id": id } }, { headers: { 'Content-Type': 'application/json' } })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('CMS/api/Pages', model)
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    }
  }
}
